import React, { PureComponent, PropTypes } from 'react';
import { Modal, Button } from 'react-fast-ui';
import EnterForm from '../../common/components/forms/EnterForm';
import ConfirmButton from '../buttons/ConfirmButton';
import cx from 'classnames';
import standardIcons from '../../util/constants/icons';

export default class SaveCancelModal extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    canSave: PropTypes.bool,
    isLoading: PropTypes.bool,
    saveClasses: PropTypes.string
  };

  static defaultProps = {
    onDelete: null,
    canSave: true,
    isLoading: false,
    saveClasses: null,
  };

  handleSubmit = () => {
    const { onSave, canSave } = this.props;
    if (canSave) {
      onSave();
    }
  };

  render() {
    const {
      onClose,
      onDelete,
      onSave,
      title,
      children,
      canSave,
      saveClasses,
      isLoading,
      closeButtonName,
      ...rest
    } = this.props;

    return (
      <Modal {...rest} onClose={onClose}>
        <Modal.Title onClose={onClose}>{title}</Modal.Title>
        <Modal.Body>
          <EnterForm onSubmit={this.handleSubmit}>
            {children}
          </EnterForm>
        </Modal.Body>
        <Modal.Footer>
          <Button loading={isLoading} text={closeButtonName || 'Cancel'}onClick={onClose}/>
          {
            onDelete &&
            <ConfirmButton
              loading={isLoading} className="mg-left-sm" onConfirm={onDelete} text="Delete" icon="trash"
              type="danger"
            />
          }
          <Button className={cx('mg-left-sm', saveClasses)} text="Save" icon={standardIcons.save} type="primary"
            disabled={!canSave}
            loading={isLoading}
            onClick={onSave}/>
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/modals/SaveCancelModal.jsx